import { Checkbox, FormControlLabel } from '@mui/material';
import { ChangeEvent } from 'react';
import { weekdays } from '../utils/dateUtils';
import { DayOfWeek } from './PricePrgClient';

type Props = {
    selectedWeekdays: DayOfWeek[];
    disabled?: boolean;
    setSelectedWeekdays(weekDays: DayOfWeek[]): void;
    disableWeekday?(weekDay: DayOfWeek): boolean;
};

export const WeekdayChooser = ({
    selectedWeekdays,
    setSelectedWeekdays,
    disabled,
    disableWeekday
}: Props) => {
    const handleWeekdaysChanged = (weekday: DayOfWeek, event: ChangeEvent<HTMLInputElement>) => {
        const added = event.target.checked;

        setSelectedWeekdays(
            added ? [...selectedWeekdays, weekday] : selectedWeekdays.filter(x => x !== weekday)
        );
    };

    return (
        <>
            {weekdays.map(([idx, weekday]) => (
                <FormControlLabel
                    key={idx}
                    control={
                        <Checkbox
                            checked={selectedWeekdays.includes(idx)}
                            onChange={e => handleWeekdaysChanged(idx, e)}
                            disabled={disabled || (disableWeekday != null && disableWeekday(idx))}
                        />
                    }
                    label={weekday}
                />
            ))}
        </>
    );
};
